/* eslint-disable no-console */
import {Flex, Form, Select} from 'antd';
import React, {useState, isValidElement} from 'react';

import {ReactComponent as PeerAveragePlus} from '../../../../assets/icons/PeerAveragePlus.svg';
import PilComp from '../../../../components/DisplayComponent/PilComp';
import {
  ESGFrameworkDetail,
  PeerAveragePopup
} from '../../../../components/DisplayModal/ESGFramework/ESGFrameworkDetail';

import {
  EnvironmentalMetrics,
  GovernanceMetrics,
  SocialMetrics
} from './constants/ESGMetrics';

const PeerBenchMarkingContent: React.FC = () => {
  const [showEsgDetailModal, setShowEsgDetailModal] = useState(false);
  const [showPeerAveragePopup, setShowPeerAveragePopup] = useState(false);
  const [peerAverageDetail, setPeerAverageDetail] = useState('');
  const [selectedMericsIndex, setSelectedMericsIndex] = useState(0);
  const [selectedCompanyName, setSelectedCompanyName] = useState('');
  const [selectedCompanyDetail, setSelectedCompanyDetail] = useState('');
  const [selectedMetricLabel, setSelectedMetricLabel] = useState<
    Record<number, string>
  >({});

  const dataArray = [
    {
      pillar: 'Environmental',
      metrics: EnvironmentalMetrics,
      color: '#BAF6EB',
      pillColor: '#98F2E1',
      isEnvironmental: true,
      average: '706.66 tCO2e',
      averageDetail: '',
      companyData: [
        {
          name: '',
          label: 'Indian Hotels Company Ltd (Taj Hotels)',
          value: 9509080,
          detail: ''
        },
        {
          name: '',
          label: 'EIH Ltd (Oberoi Hotels)',
          value: 750,
          detail: ''
        },
        {
          name: '',
          label: 'Royal Orchid Hotels Ltd',
          value: 420,
          detail: ''
        },
        {
          name: '',
          label: 'Indian Hotels Company Ltd (Taj Hotels)',
          value: 950,
          detail: ''
        },
        {
          name: '',
          label: 'EIH Ltd (Oberoi Hotels)',
          value: 750,
          detail: ''
        },
        {
          name: '',
          label: 'Royal Orchid Hotels Ltd',
          value: 420,
          detail: ''
        }
      ]
    },
    {
      pillar: 'Social',
      metrics: SocialMetrics,
      color: '#E1F3D9',
      pillColor: '#D3EEC6',
      averageDetail: `The average board diversity includes around 18–25% women representation, 
      with 45–55% independent directors and typically 1–2 female independent directors on boards. 
      Most boards have 6–9 members, and about 30% have a dedicated ESG or diversity committee.`,
      average: <PeerAveragePlus />,
      companyData: [
        {
          name: '',
          label: 'Indian Hotels Company Ltd (Taj Hotels)',
          value: '',
          detail: `The Indian Hotels Company Limited (IHCL), which owns Taj Hotels, prioritizes board diversity 
          and has a policy in place to guide its approach. This policy emphasizes the 
          importance of a diverse board, including gender diversity, and recognizes it as a key 
          element for maintaining a competitive edge. The company aims to balance various attributes 
          like skills, regional and industry experience, background, and gender to ensure a well-rounded board.`
        },
        {
          name: '',
          label: 'EIH Ltd (Oberoi Hotels)',
          value: '',
          detail: `EIH Ltd (Oberoi Hotels), which owns Taj Hotels, prioritizes board diversity 
          and has a policy in place to guide its approach. This policy emphasizes the 
          importance of a diverse board, including gender diversity, and recognizes it as a key 
          element for maintaining a competitive edge. The company aims to balance various attributes 
          like skills, regional and industry experience, background, and gender to ensure a well-rounded board.`
        },
        {
          name: '',
          label: 'Royal Orchid Hotels Ltd',
          value: '',
          detail: `Royal Orchid Hotels Ltd, which owns Taj Hotels, prioritizes board diversity 
          and has a policy in place to guide its approach. This policy emphasizes the 
          importance of a diverse board, including gender diversity, and recognizes it as a key 
          element for maintaining a competitive edge. The company aims to balance various attributes 
          like skills, regional and industry experience, background, and gender to ensure a well-rounded board.`
        }
      ]
    },
    {
      pillar: 'Governance',
      metrics: GovernanceMetrics,
      color: '#FDF6DD',
      pillColor: '#FBECB8',
      averageDetail: `Around 70–80% of companies disclose having Anti-Bribery/Anti-Corruption (ABAC) policies. 
      However, only 40–50% provide detailed procedures, such as whistleblower mechanisms or 
      third-party due diligence, in their public disclosures`,
      average: <PeerAveragePlus />,
      companyData: [
        {
          name: '',
          label: 'Indian Hotels Company Ltd (Taj Hotels)',
          value: '',
          detail: `The Indian Hotels Company Limited (IHCL) has a comprehensive 
          Anti-Bribery and Anti-Corruption (ABAC) Policy that aligns with their 
          commitment to ethical conduct and integrity in all business dealings. 
          This policy aims to prevent and counter bribery and corruption by outlining 
          guiding principles and procedures. IHCL requires its personnel to recognize and report any 
          questionable transactions or behavior, and to follow established procedures.`
        },
        {
          name: '',
          label: 'EIH Ltd (Oberoi Hotels)',
          value: '',
          detail: `EIH Ltd (Oberoi Hotels) has a comprehensive 
          Anti-Bribery and Anti-Corruption (ABAC) Policy that aligns with their 
          commitment to ethical conduct and integrity in all business dealings. 
          This policy aims to prevent and counter bribery and corruption by outlining 
          guiding principles and procedures. IHCL requires its personnel to recognize and report any 
          questionable transactions or behavior, and to follow established procedures.`
        },
        {
          name: '',
          label: 'Royal Orchid Hotels Ltd',
          value: '',
          detail: `Royal Orchid Hotels Ltd has a comprehensive 
          Anti-Bribery and Anti-Corruption (ABAC) Policy that aligns with their 
          commitment to ethical conduct and integrity in all business dealings. 
          This policy aims to prevent and counter bribery and corruption by outlining 
          guiding principles and procedures. IHCL requires its personnel to recognize and report any 
          questionable transactions or behavior, and to follow established procedures.`
        }
      ]
    }
  ];

  return dataArray?.map((item, index) => {
    return (
      <Flex
        style={{
          width: '100%',
          backgroundColor: '#ffffff',
          border: '1px solid #F3F4F8',
          borderRadius: '12px',
          padding: '20px'
        }}
        gap={45}
        key={`${item.pillar}_${index}`}
      >
        <Flex vertical gap={25} style={{width: '40%'}}>
          <PilComp
            value={item?.pillar}
            style={{
              height: '35px',
              alignContent: 'center',
              color: '#000000',
              font: 'normal normal 700 16px Montserrat',
              padding: '8px 16px',
              backgroundColor: item?.color
            }}
          />
          <Form.Item name={''} label="ESG Metric" labelCol={{span: 24}}>
            <Select
              style={{
                height: '48px',
                font: 'normal normal 700 16px Montserrat'
              }}
              defaultValue={item?.metrics?.[0]?.value}
              options={item?.metrics}
              placeholder="Choose ESG Metric"
              onChange={(value: any, option: any) => {
                const label = option?.label ?? option?.children ?? '';
                setSelectedMetricLabel((prev) => ({...prev, [index]: label}));
              }}
            />
          </Form.Item>
        </Flex>
        <Flex vertical style={{width: '60%'}} gap={6}>
          <Flex
            style={{
              border: '1px solid #B3B5BD',
              borderRadius: '4px',
              height: '55px',
              backgroundColor: item?.color,
              padding: '12px'
            }}
            align="center"
            justify="space-between"
          >
            <div
              style={{
                color: '#000000',
                font: 'normal normal 700 16px Montserrat',
                alignContent: 'center'
              }}
            >
              Peer Average
            </div>
            <div
              style={{
                borderRadius: '100px',
                backgroundColor: item?.pillColor,
                width: isValidElement(item?.average) ? '32px' : 'fit-content',
                height: isValidElement(item?.average) ? '32px' : 'fit-content',
                padding: isValidElement(item?.average) ? '8px' : '8px 16px',
                font: 'normal normal 700 16px Montserrat'
              }}
              onClick={() => {
                setPeerAverageDetail(item?.averageDetail);
                setShowPeerAveragePopup(true);
              }}
            >
              {item?.average}
            </div>
          </Flex>
          <Flex
            style={{
              border: '1px solid #B3B5BD',
              borderRadius: '4px',
              height: 'auto',
              maxHeight: '138px',
              padding: '12px 10px',
              overflowY: 'scroll'
            }}
            className="light-scroll"
            gap={8}
            vertical
          >
            <div
              style={{
                color: '#000000',
                font: 'normal normal 700 15px Montserrat'
              }}
            >
              Peer Companies
            </div>
            {item?.companyData?.map((innerItem, innerIndex) => {
              return (
                <Flex
                  vertical={false}
                  align="center"
                  justify="space-between"
                  key={`${innerItem.label}_${innerIndex}`}
                >
                  <div
                    style={{
                      color: '#404252',
                      font: 'normal normal 700 14px Montserrat'
                    }}
                  >
                    {innerItem?.label}
                  </div>
                  <div>
                    {item?.isEnvironmental ? (
                      <PilComp
                        value={`${innerItem?.value} tCO2e`}
                        style={{
                          color: '#000000',
                          font: 'normal normal 700 12px Montserrat',
                          padding: '4px 8px',
                          backgroundColor: item?.color
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: '24px',
                          aspectRatio: '1',
                          borderRadius: '100px',
                          border: '1px solid #719A5D',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                        onClick={() => {
                          setSelectedMericsIndex(index);
                          setSelectedCompanyName(innerItem?.label);
                          setSelectedCompanyDetail(innerItem?.detail);
                          setShowEsgDetailModal(true);
                        }}
                      >
                        <PeerAveragePlus />
                      </div>
                    )}
                  </div>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
        <>
          <ESGFrameworkDetail
            companyName={selectedCompanyName}
            headerTitle={selectedMetricLabel[selectedMericsIndex]}
            contentDetail={selectedCompanyDetail}
            open={showEsgDetailModal}
            onClose={() => {
              setShowEsgDetailModal(false);
            }}
          />
          <PeerAveragePopup
            contentDetail={peerAverageDetail}
            open={showPeerAveragePopup}
            onClose={() => {
              setShowPeerAveragePopup(false);
            }}
          />
        </>
      </Flex>
    );
  });
};

export default PeerBenchMarkingContent;
